import {DumpsterFire} from "../DumpsterFire";
import {DumpsterFireGameMode} from "../server/DumpsterFireGameMode";
import {DumpsterFireGameAssets} from "../DumpsterFireGameAssets";
import {gsap, TimelineLite} from "gsap";
import {BasicBitmapCountUp} from "../components/BasicBitmapCountUp";
import {ariblk} from "../Fonts";
import {DumpsterFireSound} from "../sound/DumpsterFireSound";
import {StageLayer} from "@nolimitcity/slot-keypad/bin/core/app/StageLayer";
import {ContinueButton} from "@nolimitcity/slot-keypad/bin/core/app/gui/buttons/concretebuttons/ContinueButton";
import {ScreenBounds} from "@nolimitcity/slot-keypad/bin/core/app/display/ScreenBounds";
import {NolimitApplication} from "@nolimitcity/slot-keypad/bin/core/app/NolimitApplication";
import {FontWeight} from "@nolimitcity/slot-keypad/bin/core/loaders/font/FontStatics";

export class DFFSOutroView extends PIXI.Container implements StageLayer {

    private _button: ContinueButton;
    private _outroText: PIXI.Text;
    private _sprite: PIXI.Sprite;
    private _countUp: BasicBitmapCountUp;
    private _scaleInOutTl: gsap.core.Timeline;
    private _spinsPlayed: PIXI.Text;
    private _spinsPlayedText: PIXI.Text;
    private _duckSpine: PIXI.spine.Spine;
    private clickCallback?: Function;

    constructor() {
        super();
        this.name = "DFFSOutroView";

        this.init();
    }

    public onResize(): void {
        const bounds: ScreenBounds = NolimitApplication.screenBounds;
        if (NolimitApplication.isLandscape) {
            this._button.position.set(391, 615);
        } else {
            const centerBottom = (bounds.bottom - 610) * 0.5 + 610;
            this._button.position.set(391, centerBottom - 80);
        }
    }

    public enableButton(callback: Function): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            this.clickCallback = callback;
            this.onResize();
        }, 0);
        if (DumpsterFire.model.data.wasFeatureBuy && DumpsterFire.autoPlayPlugin.isAutoplayRound && !DumpsterFire.model.data.brokeTheBank) {
            tl.to(this, {duration: 1.5});
            tl.add(() => {
                this.onButtonClick();
            })
        } else {
            tl.add(() => {
                this._button.visible = true;
            }, 0)
            tl.to(this._button, {
                alpha: 1,
                duration: 0.2
            }, "<");
            tl.add(() => {
                this._button.enable(true)
            }, ">");
        }
        return tl;
    }


    public showOutro(): TimelineLite {
        const tl: TimelineLite = new TimelineLite(),
            isWinBelowStake: boolean = DumpsterFire.isWinBelowStake(),
            winNumber: number = DumpsterFire.model.gameData.accumulatedRoundWin,
            isNoWin: boolean = (winNumber === 0.00);
        let winRatio: number = (winNumber / DumpsterFire.model.gameData.playedBetValue),
            countUpDuration: number = 0;
        if (winRatio >= 5) {
            countUpDuration = 1.5;
        } else if (winRatio >= 3) {
            countUpDuration = 1;
        }
        tl.to([this._sprite, this._duckSpine], {
            duration: 0.5,
            alpha: 1
        }, 0);

        tl.add(() => {
            this._duckSpine.visible = true;
            this._duckSpine.state.setAnimation(0, "animation", true);
            DumpsterFire.soundPlayer.switchMusic("FS_OUTRO_MUSIC");
            DumpsterFire.soundPlayer.playSound(DumpsterFireSound.FS_OUTRO_START);
            this._countUp.visible = false;
            this._sprite.visible = true;
            this._outroText.visible = !(isWinBelowStake || isNoWin);
            this._spinsPlayed.visible = true;
            DumpsterFire.keypadPlugin.setWin(DumpsterFire.model.gameData.accumulatedRoundWin, true, DumpsterFire.isWinBelowStake());
        }, 0);

        if (!(isWinBelowStake || isNoWin)) {
            tl.add([() => {
                this._countUp.visible = true;
                if (winRatio >= 5) {
                    DumpsterFire.soundPlayer.startCountUp();
                }
            },
                this._countUp.getCountAnimation(0, winNumber, countUpDuration)], 0)
            tl.add(() => {
                DumpsterFire.soundPlayer.stopOutroCountUp();
                this.getWinScaleInOutAnim();
            }, countUpDuration);
        } else {
            tl.add(() => {
                this._countUp.visible = true;
                this._countUp.stopAt(winNumber);
                if (this._countUp.width > 250) {
                    this._countUp.scale = new PIXI.Point(280 / this._countUp.width, 280 / this._countUp.width)
                }
            }, 0.2);
        }
        tl.add(() => {
            DumpsterFire.blackBg.showBlackBg();
            this._outroText.text = NolimitApplication.apiPlugin.translations.translate("YOU WON");
            this._spinsPlayed.text = DumpsterFire.model.data.freespinsPlayed.toString() || "";
        }, 0);

        if (this._spinsPlayedText.width > 201) {
            let scale = 201 / this._spinsPlayedText.width
            this._spinsPlayedText.scale.set(scale);
        }
        if (this._outroText.width > 450) {
            let scale = 450 / this._outroText.width
            this._outroText.scale.set(scale);
        }
        return tl;
    }

    private init(): void {
        this._outroText = new PIXI.Text("", {
            fontFamily: ariblk.FAMILY,
            fontSize: 63,
            fill: "#2d755e",
            stroke: "#be6565",
            strokeThickness: 5,
            fontWeight: "Bold",
            wordWrapWidth: 477,
            padding: 2,
            align: "center",
            wordWrap: true,
            dropShadow: true,
            dropShadowColor: "#000000",
            dropShadowAngle: 1,
            dropShadowDistance: 7,
        })
        this._outroText.position.set(368, 187);
        this._outroText.angle = 2;
        this._outroText.anchor.set(0.5, 0.5);
        this._outroText.visible = false;
        const textStyle: PIXI.TextStyle = new PIXI.TextStyle({
            fill: "#e78a2e",
            fontFamily: ariblk.FAMILY,
            fontSize: 20,
            stroke: "#000000",
            strokeThickness: 5,
            fontWeight: FontWeight.BOLD,
            wordWrapWidth: 201,
            padding: 2,
            dropShadow: true,
            dropShadowColor: "#361308",
            dropShadowAngle: 1,
            dropShadowDistance: 5,
        })
        const textStyle2: PIXI.TextStyle = new PIXI.TextStyle({
            fill: "#e8bf74",
            fontFamily: ariblk.FAMILY,
            fontSize: 55,
            fontWeight: FontWeight.BOLD,
            stroke: "#000000",
            strokeThickness: 5,
            wordWrapWidth: 2,
            wordWrap: true,
        });
        this._spinsPlayedText = new PIXI.Text(NolimitApplication.apiPlugin.translations.translate("Spins played"), textStyle);

        this._spinsPlayedText.position.set(10, 45);
        this._spinsPlayedText.angle = -2.5;
        this._spinsPlayedText.anchor.set(0.5);
        this._spinsPlayed = new PIXI.Text("", textStyle2);
        this._spinsPlayed.anchor.set(0.5);
        this._spinsPlayed.visible = false;
        this._spinsPlayed.angle = -3.5;
        this._spinsPlayed.position.set(420, 450);
        this._spinsPlayed.addChild(this._spinsPlayedText);

        this._button = new ContinueButton();
        this._button.addClickCallback(() => {
            this.onButtonClick();
        });
        this._button.pivot.set(this._button.width * 0.5, this._button.height * 0.5);
        this._button.enable(false)
        this._button.visible = false;
        this.onResize();

        this._sprite = new PIXI.Sprite(DumpsterFire.assetLoader.getTextures("outroSprite")[0]);
        this._sprite.visible = false;
        this._sprite.position.set(60, 0);

        this._countUp = new BasicBitmapCountUp({
            fontName: DumpsterFireGameAssets.BITMAP_OUTRO_FONT_WIN_COUNT_UP,
            fontSize: 30,
        }, 300, new PIXI.Point(0.5, 0.5));
        this._countUp.stopAt(0);
        this._countUp.position.set(372, 304);
        this._countUp.angle = 1.5;
        this._countUp.visible = false;

        this._duckSpine = new PIXI.spine.Spine(DumpsterFire.assetLoader.getSpineAsset("fsOutro_duck"));
        this._duckSpine.position.set(180, 580);
        this._duckSpine.visible = false;

        this.addChild(this._sprite, this._outroText, this._duckSpine, this._button, this._countUp, this._spinsPlayed);
        this.position.set(-32, 0);
    }

    private getWinScaleInOutAnim(): gsap.core.Timeline {
        this._scaleInOutTl = new gsap.core.Timeline({
            onStart: () => {
                this._countUp.scale.set(1);
            }
        });
        this._scaleInOutTl.to(this._countUp.scale, {duration: 0.2, x: 1.2, y: 1.2});
        this._scaleInOutTl.to(this._countUp.scale, {duration: 0.5, x: 1, y: 1});
        return this._scaleInOutTl;
    }

    private onButtonClick(): void {
        DumpsterFire.backgroundElements.resetIdleTimeline();
        this._button.enable(false);
        const tl: TimelineLite = new TimelineLite(),
            duration: number = 0.1;
        this.clickCallback!();
        tl.add(() => {
            if (DumpsterFire.model.data.nextMode !== DumpsterFireGameMode.EXTRA_SPIN) {
                DumpsterFire.soundPlayer.stopSound(DumpsterFireSound.MULTI_FIRE);
                DumpsterFire.model.isFreespin = false;
            }
        }, 0.1);
        tl.to([this._button, this._sprite, this._duckSpine], {
            duration: duration,
            alpha: 0
        }, 0.1);
        tl.add(DumpsterFire.blackBg.onComplete(), 0.2)
        tl.add(() => {
            this._duckSpine.visible = false;
            this._duckSpine.state.clearTracks();
            this._duckSpine.state.setEmptyAnimation(0, 0);
            DumpsterFire.soundPlayer.switchMusic(DumpsterFire.model.data.nextMode);
            DumpsterFire.model.boostedBetName = "";
            this._countUp.visible = false;
            this._sprite.visible = false;
            this._button.visible = false;
            this._outroText.visible = false;
            this._spinsPlayed.visible = false;
        }, 0);
        tl.add(gsap.to(this, {duration: 0.001}));
        delete this.clickCallback;
    }
}